module.exports = __webpack_public_path__ + "img/fontsize_select.b05457ce.png";